import { escapeHtml } from './formatters.js';

/**
 * Toast Notification Helper
 */
export function showToast(
  message: string,
  type: 'info' | 'success' | 'error' | 'warning' | 'warn' = 'info',
  duration: number = 3500
): void {
  const container = document.getElementById('toast-container');
  if (!container) return;

  const normalizedType = type === 'warn' ? 'warning' : type;

  const toast = document.createElement('div');
  toast.className = `toast toast-${normalizedType}`;
  toast.innerHTML = `
    <span class="toast-icon">${normalizedType === 'success' ? '✓' : normalizedType === 'error' ? '✕' : normalizedType === 'warning' ? '⚠' : 'ℹ'}</span>
    <span class="toast-message">${escapeHtml(message)}</span>
  `;

  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    toast.style.transition = 'all 0.25s ease';
    setTimeout(() => {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 250);
  }, duration);
}
